import { QcBizGuestSchema } from "../guest/QcBizGuest";
import { QcBizInquirySchema } from "./QcBizInquiry";
import { QcUserSchema } from "./QcUser";
import { z } from "zod";

export type QcBizConversationInfo = z.infer<typeof QcBizConversationInfoSchema>;
export const QcBizConversationInfoSchema = z.object({
  conversation_id: z.string().nullable(),
  state: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  close_chat_state: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  inquiry_id: z.number().nullable(),
  assign_staff_id_account: z.number().nullable(),
  staff_conversation_id: z.string().nullable(),
  inquiry_trigger: z.string().nullable(),
  responder_id: z.number().nullable(),
  responder_name: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  conversation_name: z
    .string()
    .optional()
    .transform((value) => value ?? ""),
  created_at: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  updated_at: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  staff_qc_user: QcUserSchema.nullable(),
  guest: QcBizGuestSchema.nullable(),
  forward_target_name: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  inquiry: QcBizInquirySchema.nullable(),
  live_chat_strategy: z.string().optional(),
  is_sms_chat: z
    .boolean()
    .optional()
    .transform((value) => value ?? false),
});
